import DateFilter from '@/components/date-filter';
import ManaggeResultatExamen from '@/views/examens/salle-examen/manage-resultat-examen';
import $ from 'jquery'

export default {
    name: 'salle-examen',
    components: {
        DateFilter, ManaggeResultatExamen
    },
    props: [],
    data() {
        return {
            is_loading: true,
            is_empty: false,

            result_to_fill: {
                demande_id: 0,
                examen_nom: '',
                result_examen: null,
                examen_commentaire: ''
            },
            
            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_month: false,

            fields: [ 
                {key:'patient', label: 'Patient'}, {key:'telephone', label: 'Téléphone'}, 'sexe',
                {key:'resultat',label: 'Porter résultat'}
            ],
            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            user_info: {},
            rst_toggler: 0,
            type_examen_id: 0
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            this.operations_tobe_canceled = []
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                etat_resultat: 0,
                user_id: this.userCredentials.id,
                type_examen_id: this.$route.params.examen_id
            }
            this.current_date_filter = data
            this.is_month = true
            this.getListExamenToFill()
        },
    },

    computed: {
        examen_to_flll() {
            return this.$store.getters['examen_to_flll']
        },

        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
        monthOfYear() {
            let index;
            var m = []
            for (index = 0; index <= this.current_date.getMonth() + 1; index++) {
                m[index] = this.list_months[index];
            }
            return m;
        },

        selected_date_filter() {
            return this.$store.getters['selected_date_filter']
        },
    },

    mounted() {
        this.type_examen_id = parseInt(this.$route.params.examen_id)
        this.current_date_filter = this.selected_date_filter
        this.current_date_filter.type_examen_id = this.$route.params.examen_id

        this.getListExamenToFill()

        this.user_info = {
            nom: this.userCredentials.name,
            titre: this.userCredentials.titre,
            id: this.userCredentials.id
        }
    },

    methods: {
        getListExamenToFill() {
            this.is_loading = true
            this.$store.dispatch('getExamenToFill', this.current_date_filter).then(() => {
                if(this.examen_to_flll.l_patient.length > 0) {
                    this.is_empty = false 
                } else {
                    this.is_empty = true
                } 
                this.is_loading = false
            })
        },

        fillResult(data, demande_id, patient) {
            this.rst_toggler = (this.rst_toggler == 0)?1:0
            this.result_to_fill = {
                patient: patient.patient,
                age: patient.age,
                date_naissance: patient.date_naissance,
                sexe: patient.sexe,
                telephone: patient.telephone,
                renseignement_clinique: patient.renseignement_clinique,
                demande_id: demande_id,
                examen_nom: data.examen,
                examen_commentaire: '',
                result_examen: null,
                date_demande_examen: patient.date_demande_examen,
                prescripteur: patient.prescripteur
            }

            $('.result-exam').modal('show')
        },

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                etat_resultat: 0,
                user_id: this.userCredentials.id,
                type_examen_id: this.$route.params.examen_id
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.is_month = false

            this.getListExamenToFill()
        },
    }
}
